import { lazy } from "react";
import { withSuspense } from "../CommonElements/WithSuspense";

const ForgetPassword = lazy(
  () =>
    import("../Pages/OtherPages/Authentication/ForgetPassword/ForgetPassword")
);
const Maintenance = lazy(
  () => import("../Pages/OtherPages/Authentication/Maintenance/Maintenance")
);
const RegisterSimple = lazy(
  () =>
    import("../Pages/OtherPages/Authentication/RegisterSimple/RegisterSimple")
);
const ResetPassword = lazy(
  () =>
    import("../Pages/OtherPages/Authentication/ResetPassword/ResetPassword_old") //dump
);
const ResetChangePassword = lazy(
  () => import("../Pages/OtherPages/Authentication/ResetPassword/ResetPassword")
);

const Error400 = lazy(
  () => import("../Pages/OtherPages/Error/Error400/Error400")
);
const Error401 = lazy(
  () => import("../Pages/OtherPages/Error/Error401/Error401")
);
const Error403 = lazy(
  () => import("../Pages/OtherPages/Error/Error403/Error403")
);
const Error404 = lazy(
  () => import("../Pages/OtherPages/Error/Error404/Error404")
);
const Error500 = lazy(
  () => import("../Pages/OtherPages/Error/Error500/Error500")
);
const Error503 = lazy(
  () => import("../Pages/OtherPages/Error/Error503/Error503")
);

export const authRoutes = [
  //Error
  {
    path: `/errors/error400`,
    Component: withSuspense(<Error400 />),
  },
  {
    path: `/errors/error401`,
    Component: withSuspense(<Error401 />),
  },
  {
    path: `/errors/error403`,
    Component: withSuspense(<Error403 />),
  },
  {
    path: `/errors/error404`,
    Component: withSuspense(<Error404 />),
  },
  {
    path: `/errors/error500`,
    Component: withSuspense(<Error500 />),
  },
  {
    path: `/errors/error503`,
    Component: withSuspense(<Error503 />),
  },

  {
    path: `/register`,
    Component: withSuspense(<RegisterSimple />),
  },
  {
    path: `/authentication/forgetpassword`,
    Component: withSuspense(<ForgetPassword />),
  },
  // {
  //   path: `/authentication/resetpassword`,
  //   Component: <ResetPassword />,
  // },

  {
    path: `/authentication/maintenance`,
    Component: withSuspense(<Maintenance />),
  },
];
